import * as yup from "yup";

const getCharacterValidationError = (str: string) => {
  return `Your password must have at least 1 ${str}`;
};

const username = yup.string().required("Required");

const email = yup.string().email("Invalid Email").required("Required");

const password = yup
  .string()
  .required("Please enter a password")
  .min(8, "Password must have at least 8 characters")
  .matches(/[0-9]/, getCharacterValidationError("number"))
  .matches(/[a-z]/, getCharacterValidationError("lowercase character"))
  .matches(/[A-Z]/, getCharacterValidationError("uppercase character"));

const confirmPassword = yup
  .string()
  .required("Please re-type your password")
  .oneOf([yup.ref("password")], "Passwords does not match");

const emp_id = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .integer();
const rate = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");
const loan = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");
const travel = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");
const extra = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");

const loan_cut = yup
  .number()
  .min(0, "Value must be greater than 0")
  .transform((value) => (Number.isNaN(value) ? 0 : value))
  .nullable()
  .max(yup.ref("loan"), "Value must be less than loan");

const add_hours = yup
  .number()
  .transform((value, originalValue) =>
    originalValue === "" || Number.isNaN(value) ? null : value
  )
  .nullable();

const last_increment = yup
  .date()
  .required("Date is required")
  .typeError("Date is required");

const add_cash = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");

const emp_notes = yup.string().max(800, "Cannot have more than 800 characters");

export const salaryCardValidationSchema = yup.object({
  emp_id,
  rate,
  last_increment,
  loan,
  travel,
  extra,
  loan_cut,
  add_hours,
  add_cash,
  emp_notes,
});

const part_name = yup
  .string()
  .required("Part Name is required")
  .max(200, "Cannot have more than 200 characters");

const drawing = yup
  .string()
  .required("Drawing is required")
  .max(200, "Cannot have more than 200 characters");

const parties = yup
  .array()
  .of(
    yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    })
  )
  .min(1, "At least one selection is required");

const status = yup.object({
  label: yup.string(),
  value: yup.number().required("Status is required"),
});

const party_type = yup.object({
  label: yup.string(),
  value: yup.string().required("Party Type is required"),
});

const location = yup
  .object({
    label: yup.string().required(),
    value: yup.number().required(),
  })
  .required("Location is required");

const product_line = yup
  .string()
  .max(200, "Cannot have more than 200 characters");

const incoming_remark = yup
  .string()
  .max(200, "Cannot have more than 200 characters");

const per_piece_weight = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");
const plating = yup.boolean().default(false).required("Plating is required");
const powder_coating = yup
  .boolean()
  .default(false)
  .required("Powder Coating is required");

const part_id = yup.object({
  label: yup.string(),
  value: yup.number().required("Part ID is required"),
});

export const dimension = yup
  .number()
  .transform((value) => (Number.isNaN(value) ? null : value))
  .min(0, "Value must be greater than 0");

const remarks = yup.string().required("Remarks are required");

const action_date = yup
  .date()
  .required("Date is required")
  .typeError("Date is required");

const quantity = yup
  .number()
  .required()
  .min(1, "Quantity must be greater than 0");

const discontinued = yup
  .boolean()
  .default(false)
  .required("Discontinued is required");
const laser_cutting = yup
  .boolean()
  .default(false)
  .required("Laser Cutting is required");
const drawing_link = yup
  .string()
  .url("Invalid URL")
  .max(200, "Cannot have more than 200 characters");

const variant = yup
  .string()
  .required("Required")
  .max(200, "Cannot have more than 200 characters");

const collection = yup
  .string()
  .required("Required")
  .max(200, "Cannot have more than 200 characters");

const size = yup
  .string()
  .required("Required")
  .max(10, "Cannot have more than 10 characters");

const sku_code = yup
  .string()
  .required("Required")
  .max(100, "Cannot have more than 100 characters");

const rack_number = yup
  .string()
  .max(100, "Cannot have more than 100 characters");

const inprocess_link = yup
  .string()
  .url("Invalid URL")
  .max(200, "Cannot have more than 200 characters");

const safety_stock = yup
  .number()
  .required()
  .typeError("Safety Stock is required");

const loc_par_name = yup.string().required("Name is required");
const inventory_notes = yup
  .string()
  .max(200, "Cannot have more than 200 characters");

export const locationValidationSchema = yup.object({
  label: loc_par_name,
});

export const partyValidationSchema = yup.object({
  label: loc_par_name,
  party_type: party_type,
});

export const inventoryValidationSchema = yup.object({
  part_name,
  drawing,
  location,
  parties,
  product_line,
  incoming_remark,
  per_piece_weight,
  plating,
  powder_coating,
  discontinued,
  drawing_link,
  inprocess_link,
  safety_stock,
  laser_cutting,
  notes: inventory_notes,
});

export const inventoryTanotiValidationSchema = yup.object({
  part_name,
  location,
  collection,
  variant,
  size,
  sku_code,
  rack_number,
  safety_stock,
});

const dropdownObject = yup.object({
  label: yup.string(),
  value: yup.number().required("Required"),
});

const party = yup.mixed().when("status", (status: any, schema) => {
  if (status[0]?.value === 1) {
    return dropdownObject.required("Party is required");
  }
  return yup.mixed().notRequired();
});

const barcode = yup
  .string()
  .required("Barcode is required")
  .max(100, "Cannot have more than 100 characters")
  .when("status", {
    is: (status: { value: number }) => status?.value === 0, // IN
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required("Barcode is required"),
  });

export const InOutValidationSchema = yup.object({
  part_id,
  remarks: yup.string(),
  action_date,
  quantity,
  status,
  party,
  barcode,
});

export const IncomingItemsValidationSchema = yup.object({
  part_id,
  remarks,
  action_date,
  quantity,
  status,
  party,
});

export const IncomingChallanValidationSchema = yup.object({
  action_date,
  party: dropdownObject.required("Party is required"),
});

export const IncomingChallanBulkValidationSchema = yup.object().shape({
  party: yup
    .object()
    .shape({
      value: yup.number().required("Party is required"),
      label: yup.string(),
    })
    .required("Party is required"),
  status,
  company: yup
    .object({
      label: yup.string(),
      value: yup.string().required("Company is required"),
    })
    .when("status", (status: any, schema) => {
      if (status[0]?.value === 0) {
        return yup
          .object({
            label: yup.string(),
            value: yup.string().required("Company is required"),
          })
          .required("Company is required");
      }
      return yup.mixed().notRequired();
    }),

  action_date: yup
    .date()
    .typeError("Invalid date")
    .required("Date is required"),

  partToAdd: yup.mixed().notRequired(),
  parts: yup
    .array()
    .of(
      yup.object().shape({
        part: yup
          .object({ value: yup.number().required(), label: yup.string() })
          .required("Part is required"),
        quantity: yup
          .number()
          .typeError("Quantity is required")
          .required("Quantity is required")
          .min(0.01, "Quantity must be greater than 0"),
        weight: yup
          .number()
          .typeError("Weight is required")
          .required("Weight is required")
          .min(0, "Weight must be 0 or greater"),
        remarks: yup.string().required("Remarks are required"),
        perPieceWeight: yup.number().nullable().notRequired(),
      })
    )
    .min(1, "Add at least one part"),
});

export const loginValidationSchema = yup.object({
  email,
  password,
});

export const otpValidationSchema = yup.object({
  otp: yup
    .string()
    .required("OTP is required")
    .matches(/^\d{6}$/, "OTP must be 6 digits"),
});

export const registerValidationSchema = yup.object({
  username,
  email,
  password,
  confirmPassword,
});

const laser_rate = yup
  .number()
  .min(0, "Value must be greater than 0")
  .transform((value) => (Number.isNaN(value) ? 0 : value))
  .nullable();

export const costingFormValidationSchema = yup.object({
  part_name,
  drawing_no: yup
    .string()
    .required("Drawing is required")
    .max(200, "Cannot have more than 200 characters"),
  length: dimension,
  breadth: dimension,
  thickness: dimension,
  quantity: dimension,
  raw_material_rate: dimension,
  laser_rate,
});
